// extracted by mini-css-extract-plugin
export var activityContainer = "_jf-0";
export var typingIndicatorContainer = "_jf-1";
export var typingIndicatorDot = "_jf-2";
export var wave = "_jf-3";